import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type {
  CompanyBase,
  CompanyById,
  CompanyCurrentAmountFillPayload,
  CompanyLimitUpdatePayload,
} from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/company`;

export const getList = async (params?: RequestParams): Promise<ApiResponseList<CompanyBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<CompanyBase>>(`${BASE}/index`, { params });
  return data;
};

export const getById = async (id: number): Promise<ApiResponse<CompanyById>> => {
  const { data } = await axiosInstance.get<ApiResponse<CompanyById>>(`${BASE}/show`, {
    params: { id },
  });
  return data;
};

export const updateLimit = async (payload: CompanyLimitUpdatePayload): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/limit-update`, payload);
  return data;
};

export const fillCurrentAmount = async (payload: CompanyCurrentAmountFillPayload): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${BASE}/current-amount-fill`, payload);
  return data;
};
